export const geojson = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        point_code: "P001",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 32.53127208,
        longitude: 35.14827051,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=09277639639074436ad382668fe196e64&authkey=AQv8RjySSl3lE5Qx9GLzcOY&e=mluT6x",
        content_descriptions:
          "Police make vehicle slow down, strike the vehicle and then fire grenade at it as it drives off",
        categories: "Unlawful use of force (less-lethal weapons)"
      },
      geometry: { type: "Point", coordinates: [35.14827051, 32.53127208] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P002",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.92883434,
        longitude: 35.09250794,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=08e9977664d8f4caeb24a007c7d1bc7ea&authkey=AaHe2-3H243SwXR7cQ2JYqY&e=yOVq1s",
        content_descriptions:
          "Group of people, some wearing Israeli flags, walk down Avraham Ben Shoshan St in Acre chanting ‘Death to Arabs’",
        categories: "Other"
      },
      geometry: { type: "Point", coordinates: [35.09250794, 32.92883434] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P003",
        graphic: false,
        event_date: "14 May 2021",
        latitude: 32.9255919,
        longitude: 35.0722832,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=014e5040b1e31470bbc84dfbbd69dee60&authkey=AYf73DecwlDJfZAbKgX_bms&e=lxXC8L;https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=08738234503b54857a5349be08688652d&authkey=ASe8yOJqpGcK564lnk5s__g&e=zT8pDJ",
        content_descriptions:
          "Stun grenade fired towards youth on bike without lawful justification.",
        categories: "Unlawful use of force (less-lethal weapons)"
      },
      geometry: { type: "Point", coordinates: [35.0722832, 32.9255919] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P004",
        graphic: true,
        event_date: "12 May 2021",
        latitude: 32.8193346,
        longitude: 34.9872285,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=08c3078e3d74a40768c35723cb31e376d&authkey=AS1T_U5IHazJxAcaAM6SnXg&e=yRmo43",
        content_descriptions:
          "Large group of people, some wearing Israeli flags, attack the home of a Palestinian family.",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [34.9872285, 32.8193346] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P005",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 32.04194196,
        longitude: 34.75148352,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=09b66d911d96d4b75b169b2aea60d67c8&authkey=ASNZsXEkw-cGDxy426DvR_E&e=KHsj4S",
        content_descriptions:
          "Man on motorcycle is pushed off his bike by a police officer.",
        categories: "Unlawful use of force (beating)"
      },
      geometry: { type: "Point", coordinates: [34.75148352, 32.04194196] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P006",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 31.78484,
        longitude: 35.2104415,
        events_count: 1,
        source_links:
          "https://twitter.com/LocalFocus1/status/1392874757310361603",
        content_descriptions:
          "Crowd with police presence walk through Yehuda Market chanting “Death to Arabs”.",
        categories: "Other"
      },
      geometry: {
        type: "Point",
        coordinates: [35.210441499999988, 31.78484]
      }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P007",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.8193832,
        longitude: 34.9859239,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=0d5616414da234ce18a3c9e3e2c5e0ff0&authkey=AQ38mDfsyiIsP8NDjnBgG74&e=UdZzp2",
        content_descriptions:
          "Large group of people with Israeli flags attack a vehicle with no police presence visible",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [34.9859239, 32.8193832] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P008",
        graphic: true,
        event_date: "12 May 2021",
        latitude: 32.020941,
        longitude: 34.7393561,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=0661c9b7e49ff4f53854f0bdbc45ee111&authkey=AXtongvMldYd-e36ptNrmY0&e=HoeWRK;https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=00edab08343a9451da4237d2c8ce8736f&authkey=AZphuHCArQJxU4W8SjTOcS8&e=23pi9Q;https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=0ee8da775dfdc448e905faa19b065223c&authkey=AcHWCaCcHHD4Opk6LOGbwDE&e=v50tU8",
        content_descriptions:
          "On 12 May, Said Musa, 33-year-old from Ramleh, was dragged out of his car on the Bat Yam Promenade by attackers carrying Israeli flags, and beaten with flagpoles and run over with a scooter until he fell unconscious.",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [34.7393561, 32.020941] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P009",
        graphic: true,
        event_date: "11 May 2021",
        latitude: 31.260506,
        longitude: 34.806588,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=057ee8c3bee0c48e5857d435e5036e838&authkey=AT4KgzB1hHVtprXe-XEvCU4&e=YKvrwg",
        content_descriptions:
          "Police tackling, punching, and pushing people in front of the student dormitories of Ben-Gurion University in Beersheba.",
        categories: "Unlawful use of force (beating)"
      },
      geometry: { type: "Point", coordinates: [34.806588, 31.260506] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P010",
        graphic: false,
        event_date: "11 May 2021",
        latitude: 31.926374,
        longitude: 34.862771,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=077c3b129836b4a9a9be3bd97c09484e5&authkey=AZrqcLnrJkOdXqT5tL1JBCk&e=CSxO66",
        content_descriptions:
          "Man in street holding large instrument stops and checks vehicles and inspecting drivers, then mob attacks car which speeds away. Later, police are seen running towards the site.",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [34.862771, 31.926374] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P011",
        graphic: false,
        event_date: "Unconfirmed",
        latitude: 32.81956996,
        longitude: 34.98332444,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=0fd7f87b997d44477821c3fee86e43ccf&authkey=Aa3brUUlgpZmQs83tGJr9Q0&e=GqYC7g",
        content_descriptions: "Protesters attacking car",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [34.98332444, 32.81956996] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P012",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.784729,
        longitude: 35.541309,
        events_count: 1,
        source_links:
          "https://twitter.com/BalqesZA/status/1392569928948101120;https://twitter.com/AliyaHasan_/status/1392547141453815820;https://twitter.com/TheInsiderPaper/status/1392540980222603270",
        content_descriptions:
          "Three videos showing groups waving Israeli flags attacking a car on HaGalil Street, Tiberias. The car drives away but is later stopped. There is a police vehicle stationed where the mob attacks the vehicle but there is no police activity to stop the attack on the vehicle.",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [35.541309, 32.784729] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P013",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.020634,
        longitude: 34.739337,
        events_count: 1,
        source_links:
          "https://twitter.com/oranmikel/status/1392537190077456384;https://twitter.com/ivgiz/status/1392530908616568832;https://twitter.com/daniel_elazar/status/1392547593771798535",
        content_descriptions:
          'Groups carrying Israeli flags vandalise the "Shawarma Sahara" restaurant on Bat Yam sea front.',
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [34.739337, 32.020634] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P014",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.0199835,
        longitude: 34.73930532,
        events_count: 1,
        source_links:
          "https://twitter.com/N12News/status/1392536317653921794;https://twitter.com/MaarivOnline/status/1392530127192526857",
        content_descriptions:
          "Groups carrying Israeli flags vandalise the “Victory Ice Cream” store on Bat Yam sea front.",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [34.73930532, 32.0199835] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P015",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.9291816,
        longitude: 35.0801808,
        events_count: 1,
        source_links:
          "https://twitter.com/kann_news/status/1392557639024975877;https://twitter.com/kann_news/status/1392576013822005251;https://twitter.com/ShehabAgency/status/1392571136173645828",
        content_descriptions: "Crowd attacks Jewish Israeli in Acre",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [35.0801808, 32.9291816] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P016",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 32.80600678,
        longitude: 35.10431874,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=032db4fe6517e4eb29678b7e06fc0a591&authkey=AXlSHc5e6lfTiFj6tDsTbxU&e=opgLKa",
        content_descriptions:
          "Groups of men wearing black t-shirts holding machetes on street corner in Kiryat Ata",
        categories: "Failure to Protect"
      },
      geometry: { type: "Point", coordinates: [35.10431874, 32.80600678] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P017",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 31.9558096,
        longitude: 34.900272,
        events_count: 1,
        source_links:
          "https://twitter.com/TheBelaaz/status/1392882012705509387 ",
        content_descriptions:
          "A gunman opens fire at a group of fleeing Jewish men. One man is hit in the leg and taken to hospital.",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [34.900272, 31.9558096] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P018",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 31.956687,
        longitude: 34.899658,
        events_count: 1,
        source_links:
          "https://twitter.com/OrenZiv1985/status/1392886340958703624",
        content_descriptions:
          "A gunman opens fire at a group of fleeing Jewish men. One man is hit in the leg and taken to hospital.",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [34.899658, 31.956687] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P019",
        graphic: false,
        event_date: "12 May 2021",
        latitude: 32.04711228,
        longitude: 34.75094608,
        events_count: 1,
        source_links:
          "https://twitter.com/HenrietteChacar/status/1392933082647474177?s=20",
        content_descriptions:
          "Ibrahim Souri was on his balcony observing the police patrols in his street. He was holding his phone up to record and shouted “Shoot, it’s all recorded”. He was shot in the face by what is likely to be a 40mm KIP that fractured his facial bones.",
        categories: "Unlawful use of force (less-lethal weapons)"
      },
      geometry: { type: "Point", coordinates: [34.75094608, 32.04711228] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P020",
        graphic: false,
        event_date: "10 May 2021",
        latitude: 31.95064302,
        longitude: 34.89843325,
        events_count: 1,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=027a5865e5e564a5585bbd90696f0eec2&authkey=AWRIMOBknOWYWzdRkPcxbao&e=ZZFmrq",
        content_descriptions:
          "31-year-old Musa Hassuna is shot and killed during a protest in Lod.",
        categories: "Other"
      },
      geometry: { type: "Point", coordinates: [34.89843325, 31.95064302] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P021",
        graphic: false,
        event_date: "11 May 2021",
        latitude: 31.9522623,
        longitude: 34.8961459,
        events_count: 1,
        source_links:
          "https://twitter.com/shilofreid/status/1392229651108487170",
        content_descriptions: "Fire at Ohel Yehuda Synagogue in Lod",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [34.8961459, 31.9522623] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P022",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 31.9567715,
        longitude: 34.9018095,
        events_count: 1,
        source_links:
          "https://twitter.com/ykahan/status/1393169364057313286;https://www.youtube.com/watch?v=RPk7loqRwS8",
        content_descriptions: "Aftermath of fire at Dossa Synogogue in Lod",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [34.9018095, 31.9567715] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P023",
        graphic: false,
        event_date: "11 May 2021",
        latitude: 32.920138,
        longitude: 35.066753,
        events_count: 1,
        source_links:
          "https://twitter.com/kann_news/status/1392213506364223492;https://twitter.com/CBeyar/status/1392377979364421633;https://twitter.com/dansiryoti/status/1392275605094338561",
        content_descriptions: "Jewish-owned restaurant set on fire in Acre",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [35.066753, 32.920138] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P024",
        graphic: false,
        event_date: "09 May 2021",
        latitude: 32.7057661,
        longitude: 35.30109214,
        events_count: 1,
        source_links:
          "https://twitter.com/Istanbultelaviv/status/1391518611114692610",
        content_descriptions:
          "Police launch stun grenades against protesters in the middle of traffic in the main square of Nazareth",
        categories: "Unlawful use of force (less-lethal weapons)"
      },
      geometry: { type: "Point", coordinates: [35.30109214, 32.7057661] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P025",
        graphic: false,
        event_date: "13 May 2021",
        latitude: 32.1168226,
        longitude: 34.975582,
        events_count: 1,
        source_links:
          "https://twitter.com/aljarmaqnet/status/1392733302663139335",
        content_descriptions: "Police beat a man on the ground in Kafr Qasim",
        categories: "Unlawful use of force (beating)"
      },
      geometry: { type: "Point", coordinates: [34.975582, 32.1168226] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P026",
        graphic: false,
        event_date: "10 May 2021",
        latitude: 32.7466322,
        longitude: 35.3369788,
        events_count: 1,
        source_links:
          "https://twitter.com/Marj_Alzohoor/status/1391883370901217284",
        content_descriptions:
          "Crowd of people, some wearing Palestinian flags, attack a moving vehicle with driver inside.",
        categories: "General violence (inadequate state response)"
      },
      geometry: { type: "Point", coordinates: [35.3369788, 32.7466322] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P027",
        graphic: false,
        event_date: "14 May 2021",
        latitude: 32.7455406,
        longitude: 35.3437921,
        events_count: 1,
        source_links:
          "https://twitter.com/ShehabAgency/status/1393242131213529092",
        content_descriptions:
          "Police use less-lethal weapons against crowd in Kafr Kana following the arrest of local politician, Kamal al-Khatib",
        categories: "Other"
      },
      geometry: { type: "Point", coordinates: [35.3437921, 32.7455406] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P028",
        graphic: false,
        event_date: "18 May 2021",
        latitude: 31.7915633,
        longitude: 35.2287909,
        events_count: 1,
        source_links:
          "https://twitter.com/yarahawari/status/1397619678185496576",
        content_descriptions:
          "Israeli police fire sponge round at home of Palestinian family in Sheikh Jarrah, injuring 16-year-old Janna Kiswani who was treated in hospital for fractured vertebra",
        categories: "Unlawful use of force (less-lethal weapons)"
      },
      geometry: { type: "Point", coordinates: [35.2287909, 31.7915633] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P029",
        graphic: false,
        event_date: "05 June 2021",
        latitude: 31.791583,
        longitude: 35.229972,
        events_count: 1,
        source_links: "https://twitter.com/RZabaneh/status/1401216393446670339",
        content_descriptions:
          "Al Jazeera journalist Givara Budeiri forcefully arrested by Israeli police while covering a protest in Sheikh Jarrah",
        categories: "Other"
      },
      geometry: { type: "Point", coordinates: [35.229972, 31.791583] }
    },
    {
      type: "Feature",
      properties: {
        point_code: "P030",
        graphic: false,
        event_date: "09 May 2021",
        latitude: 32.8210024,
        longitude: 34.9911233,
        events_count: 2,
        source_links:
          "https://oneamnesty.sharepoint.com/sites/app-secretariatopensend/_layouts/15/guestaccess.aspx?docid=077851befc18c49ee93599bbc77dfbb73&authkey=Afb4IZejS7g3IhHTvmOMVIc&e=c73qAs;https://twitter.com/KhJacki/status/1391465749659754502;https://twitter.com/NewpressPs/status/1391484601500160001",
        content_descriptions:
          "Police officer tries to remove peaceful protesters from a protest, then move in against the crowd.;Less-lethal weapons used on crowd of what appear to be peaceful demonstrators",
        categories:
          "Unlawful use of force (beating);Unlawful use of force (less-lethal weapons)"
      },
      geometry: { type: "Point", coordinates: [34.9911233, 32.8210024] }
    }
  ]
};
